<div class="color-bar"></div>
<div class="conteudo ml-2 mr-2">
  <div class="row caixa-filtros shadow-sm">
  </div>
  <div class="content">
    <div id="excel-table">
      <div class="container-fluid">
        <p-toolbar styleClass="mb-4 p-shadow-3">
          <ng-template pTemplate="left">
            <div class="row">
              <div class="col-md col-sm pl-1 pr-1 filter-margin">
                <button pButton label="" pTooltip="Atualizar Tabela" icon="pi pi-refresh" (click)="retornaDados()"
                  class="p-button-sm p-button-mobile mt-1">
                </button>
              </div>
              <div class="col-md col-sm pl-1 pr-1">
                <div class="filter-margin">
                  <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                      placeholder="Filtro Geral..." class="p-inputText-mobile" />
                  </span>
                </div>
              </div>
            </div>
          </ng-template>
        </p-toolbar>
        <div *ngIf="progress" class="card card-progress mt-2">
          <div class="card-body">
            <div class="d-flex justify-content-center mt-4">
              <p-progressSpinner></p-progressSpinner>
            </div>
            <p class="text-muted text-center">Carregando...</p>
          </div>
        </div>
        <div class="card p-shadow-3" *ngIf="!progress">
          <div class="card-header">
            Status Operação
          </div>
          <div class="card-body">
            <p-table #dt [columns]="selectedColumns" [columns]="cols" [value]="syntheticData" [rowHover]="true"
              [(selection)]="selectedDados" [paginator]="false" [rows]="20" [showCurrentPageReport]="true"
              sortMode="multiple"
              styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines p-datatable-responsive-demo p-shadow-3"
              currentPageReportTemplate="Mostrando {first} à {last} de {totalRecords} entradas"
              [globalFilterFields]="['codigo','nome','cnpj','termo']" [autoLayout]="false" [loading]="loading"
              paginatorDropdownAppendTo="body">
              <ng-template pTemplate="colgroup" let-columns>
                <colgroup>
                  <col *ngFor="let col of columns" [ngStyle]="{'width': col.width}">
                </colgroup>
              </ng-template>
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let principal of principal" [ngStyle]="{'text-align': principal.text}"
                    [attr.colspan]="principal.colspan" class="header-month-float"
                    style="background-color:#000;color:white;border-color: rgb(105, 105, 105);">
                    {{principal.header}}
                  </th>
                </tr>
                <tr>
                  <ng-container *ngFor="let col of columns">
                    <th [pSortableColumn]="col.field"
                      style="background-color:#000;color:white;border-color: rgb(105, 105, 105);">
                      {{col.header}}
                      <p-sortIcon [field]="col.field" class="p-sortable-colum"></p-sortIcon>
                    </th>
                  </ng-container>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-dados let-columns="columns" let-ri="rowIndex">
                <tr>
                  <ng-container *ngFor="let col of columns">
                    <td *ngIf="col.header == 'Bloqueados' " class="colorLink">
                      <a (click)="retornaDadosAnalytical(dados.dealerCode)">{{dados[col.field]}}</a>
                    </td>
                    <td *ngIf="col.header != 'Bloqueados'">
                      {{dados[col.field]}}
                    </td>
                  </ng-container>
                </tr>
              </ng-template>
              <ng-template pTemplate="footer">
                <tr>
                  <td *ngFor="let totalizador of total" class="row-float"
                    [ngClass]="{'row-float':totalizador.value === 'Total'}"
                    style="background-color:#000;color:white;border-color: rgb(105, 105, 105);">
                    {{totalizador.value}}
                  </td>
                </tr>
              </ng-template>
            </p-table>

            <div class="card" *ngIf="syntheticData?.length === 0">
              <div class="card-body bg-no-records p-shadow-3">
                <p class="full-width main-div text-muted">Nenhum Registro Encontrado</p>
              </div>
            </div>
          </div>
        </div>
        <hr>
        <ng-container *ngIf="analyticalData.length > 0">
          <div class="card p-shadow-3">
            <div class="card-body">
              <p-table id="target" #dt [columns]="selectedColumnsAnalit" [columns]="analyticalColumns"
                [value]="analyticalData" [rowHover]="true" [(selection)]="selectedColumnsAnalit" [paginator]="false"
                [rows]="10"
                styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines p-datatable-responsive-demo p-shadow-3"
                [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,20,30,50,100]"
                [globalFilterFields]="['codigo','nome','cnpj','termo']" [autoLayout]="false" [loading]="loading"
                sortMode="multiple" paginatorDropdownAppendTo="body">
                <ng-template pTemplate="header" let-columns>
                  <tr>
                    <th *ngFor="let col of columns" [pSortableColumn]="col.field"
                      style="background-color:#000;color:white;border-color: rgb(105, 105, 105);"
                      [ngStyle]="{'width': col.width}">
                      {{col.header}}
                      <p-sortIcon [field]="col.field" class="p-sortable-colum"></p-sortIcon>
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-dados let-columns="columns">
                  <tr>
                    <ng-container *ngFor="let col of columns">
                      <td *ngIf="col.header == 'Jul' " class="colorLink">
                        <a>{{dados[col.field]}}</a>
                      </td>
                      <td *ngIf="col.header != 'Jul'">
                        <span class="ui-column-title">{{col.header}}</span>
                        <ng-container *ngIf="col.field != 'tipo' ">
                          {{dados[col.field]}}
                        </ng-container>
                      </td>
                    </ng-container>
                  </tr>
                </ng-template>
              </p-table>
              <div class="card" *ngIf="analyticalData?.length === 0">
                <div class="card-body bg-no-records p-shadow-3">
                  <p class="full-width main-div text-muted">Nenhum Registro Encontrado</p>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
